<template>
    <div class="subPage">
        <div class="flex">
            <!-- 已申请 -->
            <div v-if="withDrawDetail.payStatus === 'apply'" class="flex">
                <div class="progressLine">
                    <div class="'step'">
                        <p class="dot"></p>
                        <p class="line"></p>
                        <p class="sure"></p>
                    </div>
                    <div>
                        <p class="blacklineLong"></p>
                        <p class="blackDot"></p>
                    </div>
                    <div class="step">
                        <p class="blacklineLong"></p>
                        <p class="blackDot"></p>
                    </div>
                </div>
                <div class="progressDetail">
                    <p>
                        <span>发起提现申请</span>
                        <br />
                        <span>{{ this.formate(withDrawDetail.statusApplyDate) }}</span>
                    </p>
                    <p class="now">
                        <span>商家信息核对中</span>
                        <br />
                        <!-- <span class="tip">{{ this.formate(withDrawDetail.statusPayingDate) }}</span> -->
                    </p>
                    <p>
                        <span>商家已付款</span>
                        <br />
                        <!-- <span>{{ this.formate(withDrawDetail.statusAcceptDate) }}</span> -->
                    </p>
                    <p>
                        <span>&nbsp;</span>
                        <br />
                        <span>确认到账</span>
                        <br />
                        <!-- <span>{{ this.formate(withDrawDetail.statusPaySureDate) }}</span> -->
                    </p>
                </div>
            </div>
            <!-- 已审核 -->
            <div v-if="withDrawDetail.payStatus === 'accept'" class="flex">
                <div class="progressLine">
                    <div class="'step'">
                        <p class="dot"></p>
                        <p class="line"></p>
                        <p class="dot"></p>
                    </div>
                    <div>
                        <p class="lineLong"></p>
                        <p class="sure"></p>
                    </div>
                    <div class="step">
                        <p class="blacklineLong"></p>
                        <p class="blackDot"></p>
                    </div>
                </div>
                <div class="progressDetail">
                    <p>
                        <span>发起提现申请</span>
                        <br />
                        <span>{{ this.formate(withDrawDetail.statusApplyDate) }}</span>
                    </p>
                    <p>
                        <span>商家信息核对成功</span>
                        <br />
                        <span>{{ this.formate(withDrawDetail.statusAcceptDate) }}</span>
                    </p>
                    <p class="now">
                        <span>商家已付款</span>
                        <br />
                        <!-- <span class="tip">{{ this.formate(withDrawDetail.statusAcceptDate) }}</span> -->
                    </p>
                    <p>
                        <span>&nbsp;</span>
                        <br />
                        <span>确认到账</span>
                        <br />
                        <!-- <span>{{ this.formate(withDrawDetail.statusPaySureDate) }}</span> -->
                    </p>
                </div>
            </div>
            <!-- 已付款 -->
            <div v-if="withDrawDetail.payStatus === 'paySure' || withDrawDetail.payStatus === 'paying'" class="flex">
                <div class="progressLine">
                    <div class="'step'">
                        <p class="dot"></p>
                        <p class="line"></p>
                        <p class="dot"></p>
                    </div>
                    <div>
                        <p class="lineLong"></p>
                        <p class="dot"></p>
                    </div>
                    <div>
                        <p class="lineLong"></p>
                        <p :class="confirm ? 'confirm' : 'sure'"></p>
                    </div>
                </div>
                <div class="progressDetail">
                    <p>
                        <span>发起提现申请</span>
                        <br />
                        <span>{{ this.formate(withDrawDetail.statusApplyDate) }}</span>
                    </p>
                    <p>
                        <span>商家信息核对成功</span>
                        <br />
                        <span>{{ this.formate(withDrawDetail.statusAcceptDate) }}</span>
                    </p>
                    <p>
                        <span>商家已付款</span>
                        <br />
                        <span class="tip">{{
                            withDrawDetail.payStatus === 'paySure' ?
                            this.formate(withDrawDetail.statusPaySureDate) :
                            this.formate(withDrawDetail.statusPayingDate)
                            }}</span>
                    </p>
                    <p class="now">
                        <span v-if="!confirm">&nbsp;</span>
                        <span v-if="confirm">确认到账</span>
                        <br />
                        <span v-if="!confirm">确认到账</span>
                        <span v-if="confirm">{{ this.formate(new Date()) }}</span>
                        <br />
                        <!-- <span>{{ this.formate(withDrawDetail.statusPaySureDate) }}</span> -->
                    </p>
                </div>
            </div>
            <!-- 已到账 -->
            <div v-if="withDrawDetail.payStatus === 'userSure'" class="flex">
                <div class="progressLine">
                    <div class="'step'">
                        <p class="dot"></p>
                        <p class="line"></p>
                        <p class="dot"></p>
                    </div>
                    <div>
                        <p class="lineLong"></p>
                        <p class="dot"></p>
                    </div>
                    <div>
                        <p class="lineLong"></p>
                        <p class="confirm"></p>
                    </div>
                </div>
                <div class="progressDetail">
                    <p>
                        <span>发起提现申请</span>
                        <br />
                        <span>{{ this.formate(withDrawDetail.statusApplyDate) }}</span>
                    </p>
                    <p>
                        <span>商家信息核对成功</span>
                        <br />
                        <span>{{ this.formate(withDrawDetail.statusPayingDate) }}</span>
                    </p>
                    <p>
                        <span>商家已付款</span>
                        <br />
                        <span class="tip">{{ this.formate(withDrawDetail.statusAcceptDate) }}</span>
                    </p>
                    <p>
                        <span>&nbsp;</span>
                        <br />
                        <span>确认到账</span>
                        <br />
                        <span>{{ this.formate(withDrawDetail.statusPaySureDate) }}</span>
                    </p>
                </div>
            </div>
            <!-- 已拒绝 -->
            <div v-if="withDrawDetail.payStatus === 'refuse'" class="flex">
                <div class="progressLine">
                    <div class="'step'">
                        <p class="dot"></p>
                        <p class="line"></p>
                        <p class="dot"></p>
                    </div>
                    <div>
                        <p class="lineLongRed"></p>
                        <p class="Reddot"></p>
                    </div>
                </div>
                <div class="progressDetail">
                    <p>
                        <span>发起提现申请</span>
                        <br />
                        <span>{{ this.formate(withDrawDetail.statusApplyDate) }}</span>
                    </p>
                    <p>
                        <span>商家信息核对成功</span>
                        <br />
                        <span>{{ this.formate(withDrawDetail.statusRefuseDate) }}</span>
                    </p>
                    <p>
                        <span>商家拒绝付款</span>
                        <br/>
                        <span>二维码过期/账号冻结</span>
                        <br />
                        <span>{{ this.formate(withDrawDetail.statusRefuseDate) }}</span>
                    </p>
                </div>
            </div>
        </div>

        <!-- 提现金额 -->
        <div class="flex withDraw">
            <div class="tip">提现金额</div>
            <div>￥{{ withDrawDetail.money / 100 }}</div>
        </div>

        <!-- 按钮 -->
        <br />
        <mt-button v-if="withDrawDetail.payStatus !== 'paySure' && withDrawDetail.payStatus !== 'paying'" class="cancel" @click="back">完成</mt-button>
        <mt-button v-if="withDrawDetail.payStatus === 'paySure' || withDrawDetail.payStatus === 'paying'" :disabled="isDisable" class="save" @click="confirmWithDraw">确认到账</mt-button>

        <p class="tip center">商家付款后如不处理3天后系统会自动确定到账</p>
      <go-back-home/>
    </div>
</template>

<script>
import { getQueryString, formate } from '../../utils/utils';
import { mapGetters, mapActions } from 'vuex';
// payStatus":"paySure","statusDate":1533580674000,"statusPaySureDate":1533658136000,"statusPayingDate":1533658134000,"statusAcceptDate":1533658131000,"statusApplyDate":1533580674000}
export default {
  name: 'ConfirmWithDraw',
  meta:{page:true},
  computed: {
    ...mapGetters('user', {
        withDrawList: 'getWithDrawList',
    }),
  },
  methods: {
      back: function() {
          this.$router.push('/user/withDraw');
      },
      confirmWithDraw: function() {
      	//防止重复提交
      	this.isDisable = true
        setTimeout(() => {
          this.isDisable = false
        }, 3000)
        this.confirm = true;
        this.$store.dispatch('user/confirmWithDraw', this.withDrawDetail.id);
      }
  },
  created() {
      this.withDrawDetail = this.withDrawList.find(s => s.id == getQueryString('withDrawId'));
      this.formate = formate;
  },
  data() {
        return {
        	isDisable: false,
            confirm: false,
            payStatus: ['apply', 'accept', 'paying', 'paySure', 'userSure', 'refuse'],
            withDrawDetail: {
                statusApplyDate: '',
                statusPayingDate: '',
                statusAcceptDate: '',
                statusPaySureDate: '',
            }
        }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.refuled {
    color: red !important;
    font-size: .18rem;
}
.cancel {
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
    border-color: #009688;
    border: 1px solid #009688;
    color: #009688;
}
.save {
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
    border-color: #009688;
    background: #009688;
    color: #fff;
}
.flex {
    padding-top: .2rem;
    margin-left: .25rem;
    margin-right: .25rem;
}
.progressLine {
    height: 3.5rem;
    width: 1rem;
}
.progressLine div {
    text-align: center;
    height: .95rem;
}
.progressDetail {
    margin-top: -.1rem;
}
.progressDetail p {
    color: #7F7F7F;
    font-size: .16rem;
    margin: auto;
    height: .875rem;
}
.dot {
    margin: auto;
    width: .1rem !important;
    height: .1rem !important;
    background: #009688;
    border-radius: 50%;
}
.blackDot {
    margin: auto !important;
    width: .1rem !important;
    height: .1rem !important;
    background: #cdcdcd !important;
    border-radius: 50% !important;
}
.Reddot {
    margin: auto;
    width: .1rem;
    height: .1rem;
    background: red !important;
    border-radius: 50%;
}
.line {
    margin: auto;
    width: .02rem;
    height: .75rem;
    background: #009688;
}
.lineLong {
    margin: auto;
    width: .02rem;
    height: .85rem;
    background: #009688;
}
.blacklineLong {
    margin: auto;
    width: .02rem;
    height: .9rem;
    background: #cdcdcd;
}
.lineLongRed {
    margin: auto;
    width: .02rem;
    height: .9rem;
    background: red !important;
}
.now {
    color: #000000 !important;
    font-size: .18rem;
}
.step p {
    background: #cdcdcd;
}

.withDraw {
    padding-top: .16rem;
    border-top: 1px solid #cdcdcd;
    font-size: .16rem;
    justify-content: space-between;
}
.tip {
    color: #7F7F7F;
}
.center {
    margin-top: .1rem;
    font-size: .16rem;
    text-align: center;
}
.sure::after{
    content: url('../../../static/img/sure.svg');
}
.confirm::after{
    content: url('../../../static/img/confirm.svg');
}
.subPage {
    background: #fff;
    position: absolute;
    height: 100%;
    width: 100%;
    margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/page/ConfirmWithDraw.vue